export const SERVICE_MESSAGES = {
  GENERAL_OOPS_ERROR: {
    key: 'GENERAL_OOPS_ERROR',
    value: 'Oops! Something went wrong!',
  },
  GENERAL_TRY_AGAIN_ERROR: {
    key: 'GENERAL_OOPS_ERROR',
    value: 'Something went wrong. Please reload the page and try again.',
  },
};

export const API_ERROR_MESSAGES = {
  REQUEST_EMPTY: {
    key: 'REQUEST_EMPTY',
    value: 'Something went wrong. Please try again.',
  },
  INVALID_TOKEN: {
    key: 'INVALID_TOKEN',
    value: 'Invalid token',
  },
  TOKEN_REQUIRED_IN_HEADER: {
    key: 'TOKEN_REQUIRED_IN_HEADER',
    value: 'Token is a required parameter in header',
  },
  SUBSCRIPTION_ID_INVALID: {
    key: 'SUBSCRIPTION_ID_INVALID',
    value: 'Invalid subscription id',
  },
  SUBSCRIPTION_ID_REQUIRED: {
    key: 'SUBSCRIPTION_ID_REQUIRED',
    value: 'Subscription id is a required parameter in header',
  },
  NO_PERMISSION: {
    key: 'NO_PERMISSION',
    value: "You don't have permission to access this API",
  },
  LICENSE_EXPIRED: {
    key: 'LICENSE_EXPIRED',
    value: 'License expired',
  },
  LICENSE_SUSPENDED: {
    key: 'LICENSE_SUSPENDED',
    value: 'License suspended',
  },
  LICENSE_KEY_INVALID: {
    key: 'LICENSE_KEY_INVALID',
    value: 'License key invalid',
  },
  LICENSE_FEATURES_NOT_DEFINED: {
    key: 'LICENSE_FEATURES_NOT_DEFINED',
    value: 'License features not defined',
  },
  LICENSE_NOT_GENUINE: {
    key: 'LICENSE_NOT_GENUINE',
    value: 'License is not genuine. Please activate license with genuine key',
  },
  LICENSE_GRACE_PERIOD_OVER: {
    key: 'LICENSE_GRACE_PERIOD_OVER',
    value: 'License grace period over',
  },
  LICENSE_NOT_ACTIVATED: {
    key: 'LICENSE_NOT_ACTIVATED',
    value: 'License not activated',
  },
  TOKEN_OR_SUBSCRIPTION_KEY_REQUIRED: {
    key: 'TOKEN_OR_SUBSCRIPTION_KEY_REQUIRED',
    value: 'Either subscription key or token is required',
  },
  SUBSCRIPTION_KEY_INVALID: {
    key: 'SUBSCRIPTION_KEY_INVALID',
    value: 'Subscription key is invalid',
  },
  LOCK_NOT_FOUND_TO_DELETE: {
    key: 'LOCK_NOT_FOUND_TO_DELETE',
    value: 'No locks found to delete',
  },
  LOCK_MULTIPLE_FOUND: {
    key: 'LOCK_MULTIPLE_FOUND',
    value: 'Multiple locks found',
  },

  FONT_FILE_MISSING: {
    key: 'FONT_FILE_MISSING',
    value: 'One of the font file missing',
  },
  FONT_BOLD_ITALIC: {
    key: 'FONT_BOLD_ITALIC',
    value: 'Problem in uploading bold/italic font file',
  },
  FONT_ITALIC: {
    key: 'FONT_ITALIC',
    value: 'Problem in uploading italic font file',
  },
  FONT_BOLD: {
    key: 'FONT_BOLD',
    value: 'Problem in uploading bold font file',
  },
  FONT_REGULAR: {
    key: 'FONT_REGULAR',
    value: 'Problem in uploading regular font file',
  },
  FILE_TYPE_REQUIRED: {
    key: 'FILE_TYPE_REQUIRED',
    value: 'fileType is a required parameter',
  },
  FILE_TYPE_NOT_ALLOWED: {
    key: 'FILE_TYPE_NOT_ALLOWED',
    value: 'file type can only be of type: font, pdf, image, and svg',
  },
  FONT_NAME_REQUIRED: {
    key: 'FONT_NAME_REQUIRED',
    value: 'font name is required',
  },
  FILE_REGULAR_REQUIRED: {
    key: 'FILE_REGULAR_REQUIRED',
    value: 'font file regular is required',
  },
  FILE_BOLD_REQUIRED: {
    key: 'FILE_BOLD_REQUIRED',
    value: 'font file bold is required',
  },
  FILE_ITALIC_REQUIRED: {
    key: 'FILE_ITALIC_REQUIRED',
    value: 'font file italic is required',
  },
  FILE_BOLD_ITALIC_REQUIRED: {
    key: 'FILE_BOLD_ITALIC_REQUIRED',
    value: 'font file bold/italic is required',
  },
  FILE_IMAGE_REQUIRED: {
    key: 'FILE_IMAGE_REQUIRED',
    value: 'image file is required',
  },
  IMAGE_UPLOAD: {
    key: 'IMAGE_UPLOAD',
    value: 'Problem in uploading image file',
  },
  FONT_FILE_MISSING_REQUIRED: {
    key: 'FONT_FILE_MISSING_REQUIRED',
    value: 'At least one of the font file is required',
  },
  KEY_FONTS_MISSING: {
    key: 'KEY_FONTS_MISSING',
    value: 'Key fonts missing in incoming JSON',
  },
  SVG_FILE_TRANSLATE_ISSUE: {
    key: 'SVG_FILE_TRANSLATE_ISSUE',
    value: 'Problem in translating SVG file',
  },
  PROBLEM_LOADING_FONT_FROM_FILE: {
    key: 'PROBLEM_LOADING_FONT_FROM_FILE',
    value:
      'Problem in loading font from file. Possible Reasons may be, ' +
      "File is corrupted, PDFBOX doesn't support this File Format. If file is not a ttf file, try converting to ttf and then upload",
  },
  FONT_INVALID_URL: {
    key: 'FONT_INVALID_URL',
    value: 'Invalid font URL. Only Google fonts are allowed.',
  },
  INVALID_BARCODE_TYPE: {
    key: 'INVALID_BARCODE_TYPE',
    value: 'Invalid barcode type',
  },
  ORGANIZATION_ID_REQUIRED: {
    key: 'ORGANIZATION_ID_REQUIRED',
    value: 'Organization id is a required parameter',
  },
  ORGANIZATION_STORAGE_FULL: {
    key: 'ORGANIZATION_STORAGE_FULL',
    value: 'Organization storage is full',
  },

  TEMPLATE_VARIABLES_MISSING: {
    key: 'TEMPLATE_VARIABLES_MISSING',
    value: 'Template variables missing',
  },
  TEMPLATE_VARIABLE_PARSING_DATE_ERROR: {
    key: 'TEMPLATE_VARIABLE_PARSING_DATE_ERROR',
    value: 'Error in parsing date',
  },
  TEMPLATE_GENERATION_PAGES_LIMIT_EXCEEDED: {
    key: 'TEMPLATE_GENERATION_PAGES_LIMIT_EXCEEDED',
    value: 'PDF generation limit exceeded',
  },
  TRANSACTION_LIMIT_EXCEEDED: {
    key: 'TRANSACTION_LIMIT_EXCEEDED',
    value: 'Transaction limit exceeded.',
  },
  TEMPLATE_NAME_UNIQUE: {
    key: 'TEMPLATE_NAME_UNIQUE',
    value: 'Template Name should be not null and Unique',
  },
  TEMPLATE_CATEGORY_NOT_EXIST: {
    key: 'TEMPLATE_CATEGORY_NOT_EXIST',
    value: "Template category doesn't exist",
  },
  TEMPLATE_SHARE_TYPE_ALLOWED_VALUES: {
    key: 'TEMPLATE_SHARE_TYPE_ALLOWED_VALUES',
    value: "share type allowed values are 'none', 'department' or 'company'",
  },
  TEMPLATE_PRINT_TEST_FAILS: {
    key: 'TEMPLATE_PRINT_TEST_FAILS',
    value: 'Error while test printing template',
  },
  TEMPLATE_VARIABLE_NAME_NULL: {
    key: 'TEMPLATE_VARIABLE_NAME_NULL',
    value: 'Variable name of template variable can not be null',
  },
  TEMPLATE_VARIABLE_MAX_LENGTH_NULL: {
    key: 'TEMPLATE_VARIABLE_MAX_LENGTH_NULL',
    value: 'Variable max length of template variable can not be null',
  },
  TEMPLATE_ID_NOT_NULL: {
    key: 'TEMPLATE_ID_NOT_NULL',
    value: 'Template id can not be null',
  },
  TEMPLATE_ID_NOT_INTEGER: {
    key: 'TEMPLATE_ID_NOT_INTEGER',
    value: 'Template id should be integer',
  },
  TEMPLATE_ID_NOT_EXIST: {
    key: 'TEMPLATE_ID_NOT_EXIST',
    value: "Template for id doesn't exist",
  },
  TEMPLATE_FONT_NOT_EXIST: {
    key: 'TEMPLATE_FONT_NOT_EXIST',
    value: "Font doesn't exist",
  },
  TEMPLATE_ELEMENT_RENDER_ERROR: {
    key: 'TEMPLATE_ELEMENT_RENDER_ERROR',
    value: 'Error in rendering element: ',
  },
  TEMPLATE_LOCKING_ERROR: {
    key: 'TEMPLATE_LOCKING_ERROR',
    value: 'Template already locked',
  },
  TEMPLATE_CLIENT_EDIT_MASTER: {
    key: 'TEMPLATE_CLIENT_EDIT_MASTER',
    value: 'Client user cannot edit master template.',
  },
  TEMPLATE_MASTER_EDIT_PUBLISH_STATUS: {
    key: 'TEMPLATE_MASTER_EDIT_PUBLISH_STATUS',
    value: 'Master user cannot update publish status of a template.',
  },
  PUBLISHER_ROLE_REQUIRED: {
    key: 'PUBLISHER_ROLE_REQUIRED',
    value: 'Publisher role required for updating publishing status.',
  },
  TEMPLATE_USED_AS_ATTACHMENT: {
    key: 'TEMPLATE_USED_AS_ATTACHMENT',
    value: 'Template attached to email emplate',
  },
  PAGE_ID_NOT_NULL: {
    key: 'PAGE_ID_NOT_NULL',
    value: 'Page Id can Not be Null',
  },
  TARGET_LANGUAGE_NOT_NULL: {
    key: 'TARGET_LANGUAGE_NOT_NULL',
    value: 'Target language cannot be null',
  },
  PUBLISHED_ID_AND_TEMPLATE_ID_NULL: {
    key: 'PUBLISHED_ID_AND_TEMPLATE_ID_NULL',
    value: 'Both TemplateId and PublishedId can not be null',
  },
  PUBLISHED_ID_NOT_EXIST: {
    key: 'PUBLISHED_ID_NOT_EXIST',
    value: "PublishedId doesn't exist",
  },
  ACTIVE_PUBLISHED_TEMPLATE_ID_NOT_EXIST: {
    key: 'ACTIVE_PUBLISHED_TEMPLATE_ID_NOT_EXIST',
    value: "PublishedId doesn't exist or active for templateId",
  },
  PUBLISH_ID_REQUIRED: {
    key: 'PUBLISH_ID_REQUIRED',
    value: 'PublishedId is required',
  },
  STATUS_PARAM_REQUIRED: {
    key: 'STATUS_PARAM_REQUIRED',
    value: 'status is required',
  },
  MASTER_ACCESSING_USER_TEMPLATE: {
    key: 'MASTER_ACCESSING_USER_TEMPLATE',
    value: "Master user don't have access to client's template",
  },
  MASTER_LOCKING_USER_TEMPLATE: {
    key: 'MASTER_LOCKING_USER_TEMPLATE',
    value: "Master user can not lock client's template",
  },
  CLIENT_LOCKING_MASTER_TEMPLATE: {
    key: 'CLIENT_LOCKING_MASTER_TEMPLATE',
    value: 'Client user can not lock master template',
  },
  TEMPLATE_ALREADY_TRANSLATED: {
    key: 'TEMPLATE_ALREADY_TRANSLATED',
    value: 'Template already translated to specified language',
  },
  MASTER_CANNOT_TRANSLATE_CLIENT_TEMPLATE: {
    key: 'MASTER_CANNOT_TRANSLATE_CLIENT_TEMPLATE',
    value: "Master user cannot translate client's template",
  },
  CLIENT_CANNOT_TRANSLATE_MASTER_TEMPLATE: {
    key: 'CLIENT_CANNOT_TRANSLATE_MASTER_TEMPLATE',
    value: 'Client user cannot translate master template',
  },
  MASTER_TEMPLATE_CANNOT_BE_TRANSLATED: {
    key: 'MASTER_TEMPLATE_CANNOT_BE_TRANSLATED',
    value: 'Master template cannot be translated',
  },
  PROCESSED_PDF_STORAGE_SHOULD_NOT_BE_LOCAL: {
    key: 'PROCESSED_PDF_STORAGE_SHOULD_NOT_BE_LOCAL',
    value: 'Storage service for processed PDF should not be local',
  },
  QA_READY_ID_AND_TEMPLATE_ID_NULL: {
    key: 'QA_READY_ID_AND_TEMPLATE_ID_NULL',
    value: 'Both TemplateId and QaReadyTemplateId can not be null',
  },
  QA_READY_ID_NOT_EXIST: {
    key: 'QA_READY_ID_NOT_EXIST',
    value: "QaReadyId doesn't exist",
  },
  ACTIVE_QA_READY_ID_NOT_EXIST: {
    key: 'ACTIVE_QA_READY_ID_NOT_EXIST',
    value: "Active QaReadyId does'nt exist for given template id",
  },
  ONLY_ACTIVE_REFERENCED_ELEMENT_ALLOWED: {
    key: 'ONLY_ACTIVE_REFERENCED_ELEMENT_ALLOWED',
    value: 'Only active referenced values allowed',
  },
  INVALID_ACROFORM_FIELD_NAMES: {
    key: 'INVALID_ACROFORM_FIELD_NAMES',
    value: 'Fillable form element field name should be unique',
  },
  FAILED_TO_FETCH_TEMPLATE: {
    key: 'FAILED_TO_FETCH_TEMPLATE',
    value: 'Error while fetching email templates',
  },

  CATEGORY_NAME_UNIQUE: {
    key: 'CATEGORY_NAME_UNIQUE',
    value: 'Category name should be not null and unique',
  },
  CATEGORY_TYPE_ALLOWED_VALUES: {
    key: 'CATEGORY_TYPE_ALLOWED_VALUES',
    value: 'Category type should be not null and allowed values are "template" or "element"',
  },
  CATEGORY_ID_NOT_NULL: {
    key: 'CATEGORY_ID_NOT_NULL',
    value: "Category id can't be null or empty",
  },
  CATEGORY_ID_NOT_INTEGER: {
    key: 'CATEGORY_ID_NOT_INTEGER',
    value: 'Category id should be integer',
  },
  CATEGORY_ID_NOT_EXIST: {
    key: 'CATEGORY_ID_NOT_EXIST',
    value: "Category for id doesn't exist",
  },
  CATEGORY_NAME_LENGTH: {
    key: 'CATEGORY_NAME_LENGTH',
    value: 'Category name can not have more than 45 characters',
  },
  INVALID_CATEGORY_TYPE: {
    key: 'INVALID_CATEGORY_TYPE',
    value: 'Invalid category type',
  },
  INVALID_USER_TYPE: {
    key: 'INVALID_USER_TYPE',
    value: 'Invalid user type',
  },
  INVALID_FORMAT: {
    key: 'INVALID_FORMAT',
    value: 'Invalid format',
  },
  INVALID_ACCESS_TYPE: {
    key: 'INVALID_ACCESS_TYPE',
    value: 'Invalid access type',
  },
  INVALID_TEMPLATE_STATUS: {
    key: 'INVALID_TEMPLATE_STATUS',
    value: 'Incorrect email template status',
  },
  INVALID_ENV_TYPE: {
    key: 'INVALID_ENV_TYPE',
    value: 'Invalid environment type',
  },
  INVALID_CHANNEL_TYPE: {
    key: 'INVALID_CHANNEL_TYPE',
    value: 'Invalid channel type',
  },
  INVALID_LOCK_TYPE: {
    key: 'INVALID_LOCK_TYPE',
    value: 'Invalid lock type',
  },
  ORGANIZATION_ID_OF_USER_NOT_SAME_AS_CATEGORY: {
    key: 'ORGANIZATION_ID_OF_USER_NOT_SAME_AS_CATEGORY',
    value: 'Organization of user is not same as organization of category',
  },
  FAILED_TO_GET_CATEGORY_IDS: {
    key: 'FAILED_TO_GET_CATEGORY_IDS',
    value: 'Error while fetching categoryIds',
  },
  FOLDER_NAME_UNIQUE: {
    key: 'FOLDER_NAME_UNIQUE',
    value: 'Folder name should be not null and unique',
  },
  FOLDER_ID_NOT_NULL: {
    key: 'FOLDER_ID_NOT_NULL',
    value: "Folder id can't null",
  },
  FOLDER_ID_NOT_INTEGER: {
    key: 'FOLDER_ID_NOT_INTEGER',
    value: 'Folder id should be integer',
  },
  FOLDER_ID_NOT_EXIST: {
    key: 'FOLDER_ID_NOT_EXIST',
    value: "Folder for id doesn't exist or user doesn't have permission to update",
  },
  FOLDER_PARENT_ID_NOT_EXIST: {
    key: 'FOLDER_PARENT_ID_NOT_EXIST',
    value: "Folder for parentId doesn't exist",
  },
  FOLDER_ELEMENT_TYPE_ALLOWED_VALUES: {
    key: 'FOLDER_ELEMENT_TYPE_ALLOWED_VALUES',
    value:
      'Folder element type should be not null and allowed values are "userelement" or "masterelement"',
  },
  FOLDER_ELEMENT_ID_NOT_NULL: {
    key: 'FOLDER_ELEMENT_ID_NOT_NULL',
    value: "Folder element id can't be null",
  },
  FOLDER_ELEMENT_ID_NOT_EXIST: {
    key: 'FOLDER_ELEMENT_ID_NOT_EXIST',
    value: "Folder element id doesn't exist",
  },
  FOLDER_ELEMENT_ID_NOT_NULL_2: {
    key: 'FOLDER_ELEMENT_ID_NOT_NULL_2',
    value: "Folder element id can't be null",
  },
  FOLDER_ELEMENT_HAVING_ID_NOT_EXIST: {
    key: 'FOLDER_ELEMENT_HAVING_ID_NOT_EXIST',
    value: "Folder element having id doesn't exist",
  },
  FOLDER_ELEMENT_ID_NOT_INTEGER: {
    key: 'FOLDER_ELEMENT_ID_NOT_INTEGER',
    value: 'Folder element id should be an integer',
  },
  FOLDER_NAME_LENGTH: {
    key: 'FOLDER_NAME_LENGTH',
    value: 'Folder name can not have more than 45 characters',
  },
  INVALID_FOLDER_TYPE: {
    key: 'INVALID_FOLDER_TYPE',
    value: 'Invalid folder type',
  },
  EFAX_CUSTOMER_KEY_UNIQUE: {
    key: 'EFAX_CUSTOMER_KEY_UNIQUE',
    value: 'Customer key should be unique',
  },
  EFAX_CUSTOMER_KEY_NULL: {
    key: 'EFAX_CUSTOMER_KEY_NULL',
    value: 'Customer key should be not null',
  },
  EFAX_ERROR_FETCHING_USER_INFO: {
    key: 'EFAX_ERROR_FETCHING_USER_INFO',
    value: 'Error in fetching UserInfo from Efax Portal',
  },
  EFAX_USER_NAME: {
    key: 'EFAX_USER_NAME',
    value: 'User name should be unique and not null',
  },
  ELEMENT_NAME_UNIQUE: {
    key: 'ELEMENT_NAME_UNIQUE',
    value: 'Element name should be unique and can not be null',
  },
  ELEMENT_NAME_LENGTH: {
    key: 'ELEMENT_NAME_LENGTH',
    value: 'Element name can not have more than 200 characters',
  },
  REFERENCED_ELEMENT_IS_USED: {
    key: 'REFERENCED_ELEMENT_IS_USED',
    value: 'Referenced element is used in templates',
  },
  INVALID_ELEMENT_TYPE: {
    key: 'INVALID_ELEMENT_TYPE',
    value: 'Invalid element type',
  },
  INVALID_FROM: {
    key: 'INVALID_FROM',
    value: 'Invalid from',
  },
  INVALID_REFERENCED: {
    key: 'INVALID_REFERENCED',
    value: 'Invalid referenced',
  },
  INVALID_RG_PERMISSION: {
    key: 'INVALID_RG_PERMISSION',
    value: 'Invalid RG permission',
  },
  INVALID_STATUS: {
    key: 'INVALID_STATUS',
    value: 'Invalid status',
  },
  INVALID_QA_READY_STATUS: {
    key: 'INVALID_QA_READY_STATUS',
    value: 'Invalid Qa Ready status',
  },
  INVALID_RESPONSE_TYPE: {
    key: 'INVALID_RESPONSE_TYPE',
    value: 'Invalid response type',
  },
  RESPONSE_TYPE: {
    key: 'RESPONSE_TYPE',
    value: 'Response type is a required parameter',
  },
  BARCODE_VARIABLE_NULL: {
    key: 'BARCODE_VARIABLE_NULL',
    value: 'Variable not assigned to barcode',
  },
  INVALID_HTML_RESOURCE_TYPE: {
    key: 'INVALID_HTML_RESOURCE_TYPE',
    value: 'Invalid Html resource type',
  },
  INVALID_ATTACHMENT_RESOURCE_TYPE: {
    key: 'INVALID_ATTACHMENT_RESOURCE_TYPE',
    value: 'Invalid attachment resource type',
  },
  INVALID_RESOURCE_TYPE: {
    key: 'INVALID_RESOURCE_TYPE',
    value: 'Invalid html or attachment resource type',
  },
  INVALID_ATTACHMENT_PASSWORD: {
    key: 'INVALID_ATTACHMENT_PASSWORD',
    value: 'Attachment password should be not null or not empty',
  },
  ELEMENT_DOES_NOT_EXIST: {
    key: 'ELEMENT_DOES_NOT_EXIST',
    value: "Element does not exists for given Id, or doesn't belong to logged in user",
  },
  RESOURCE_GROUP_UNIQUE: {
    key: 'RESOURCE_GROUP_UNIQUE',
    value: 'ResourceGroup name can not be null and should be unique',
  },
  RESOURCE_GROUP_NAME_LENGTH: {
    key: 'RESOURCE_GROUP_NAME_LENGTH',
    value: 'ResourceGroup name can not have more than 200 characters',
  },
  RESOURCE_GROUP_NOT_NULL: {
    key: 'RESOURCE_GROUP_NOT_NULL',
    value: 'ResourceGroup Id can not be null or empty',
  },
  RESOURCE_GROUP_ID_NOT_EXIST: {
    key: 'RESOURCE_GROUP_ID_NOT_EXIST',
    value: "ResourceGroup For Id doesn't exist",
  },
  RESOURCE_GROUP_CAN_NOT_BE_DELETED: {
    key: 'RESOURCE_GROUP_CAN_NOT_BE_DELETED',
    value: 'Cannot delete as resources are attached to ResourceGroup',
  },
  FAILED_TO_ADD_RESOURCE_GROUP: {
    key: 'FAILED_TO_ADD_RESOURCE_GROUP',
    value: 'Failed to add team',
  },
  FAILED_TO_UPDATE_RESOURCE_GROUP: {
    key: 'FAILED_TO_UPDATE_RESOURCE_GROUP',
    value: 'Failed to update team name',
  },
  FAILED_TO_DELETE_RESOURCE_GROUP: {
    key: 'FAILED_TO_DELETE_RESOURCE_GROUP',
    value: 'Failed to delete team',
  },
  FAILED_TO_GET_RESOURCE_GROUP: {
    key: 'FAILED_TO_GET_RESOURCE_GROUP',
    value: 'Failed to get teams',
  },
  FAILED_TO_GET_RESOURCE_GROUP_PERMISSION: {
    key: 'FAILED_TO_GET_RESOURCE_GROUP_PERMISSION',
    value: 'Failed to get team permissions',
  },
  FAILED_TO_GET_RESOURCE_GROUP_IDS: {
    key: 'FAILED_TO_GET_RESOURCE_GROUP_IDS',
    value: 'Failed To get resource group Ids',
  },

  INVALID_CREDENTIALS: {
    key: 'INVALID_CREDENTIALS',
    value: 'Login Fails. Invalid credentials',
  },
  EMAIL_INVALID: {
    key: 'EMAIL_INVALID',
    value: 'Invalid Email',
  },
  EMAIL_ALREADY_EXIST: {
    key: 'EMAIL_ALREADY_EXIST',
    value: 'User with email already exists',
  },
  FIRST_NAME_NULL: {
    key: 'FIRST_NAME_NULL',
    value: "First name can't be null",
  },
  CHARACTER_COUNT_ERROR: {
    key: 'CHARACTER_COUNT_ERROR',
    value: 'First name is too big. Try less than 45 characters',
  },
  LAST_NAME_NULL: {
    key: 'LAST_NAME_NULL',
    value: "Last name can't be null",
  },
  EMAIL_NULL: {
    key: 'EMAIL_NULL',
    value: "email can't be null",
  },
  USER_TYPE_NULL: {
    key: 'USER_TYPE_NULL',
    value: "User type can't be null",
  },
  USER_TYPE_VALUE_NOT_ALLOWED: {
    key: 'USER_TYPE_VALUE_NOT_ALLOWED',
    value: 'Allowed values for userType are {"master", "client"}',
  },
  ROLES_NULL: {
    key: 'ROLES_NULL',
    value: "Roles can't be null",
  },
  ROLES_INVALID: {
    key: 'ROLES_INVALID',
    value: "User can't be assigned with the selected roles",
  },
  USER_NOT_EXIST: {
    key: 'USER_NOT_EXIST',
    value: "User with given id doesn't exist.",
  },
  USER_ID_NULL: {
    key: 'USER_ID_NULL',
    value: "id can't be null",
  },
  ROLE_ID_NOT_AVAILABLE: {
    key: 'ROLE_ID_NOT_AVAILABLE',
    value: 'roleId not available',
  },
  PERMISSION_IDS_NOT_AVAILABLE: {
    key: 'PERMISSION_IDS_NOT_AVAILABLE',
    value: 'permissionIds not available',
  },
  PERMISSION_IDS_ACTION_NOT_NULL: {
    key: 'PERMISSION_IDS_ACTION_NOT_NULL',
    value: "permission action cannot be null and allowed values are 'allow' and 'deny'",
  },
  RESOURCE_GROUP_PERMISSION_MANDATORY: {
    key: 'RESOURCE_GROUP_PERMISSION_MANDATORY',
    value: 'Resource group permission is mandatory',
  },
  SET_PASSWORD_LINK_EXPIRED: {
    key: 'SET_PASSWORD_LINK_EXPIRED',
    value: 'Link for setting password expired',
  },
  SET_PASSWORD_LINK_FORGED: {
    key: 'SET_PASSWORD_LINK_FORGED',
    value: 'Link is forged',
  },
  SET_PASSWORD_DOES_NOT_EXIST: {
    key: 'SET_PASSWORD_DOES_NOT_EXIST',
    value: 'Link does not exist',
  },
  ACTIVE_DIRECTORY_UNIQUE_ID_REQUIRED: {
    key: 'ACTIVE_DIRECTORY_UNIQUE_ID_REQUIRED',
    value: 'Active directory unique id (adid) required',
  },
  USER_NOT_ADDED_IN_DOCSTUDIO_APP: {
    key: 'USER_NOT_ADDED_IN_DOCSTUDIO_APP',
    value: 'User not added Yet.',
  },
  AD_USER_ALREADY_ADDED_TO_DOCSTUDIO: {
    key: 'AD_USER_ALREADY_ADDED_TO_DOCSTUDIO',
    value: 'user with this username already added',
  },
  INVALID_CREDENTIALS_2: {
    key: 'INVALID_CREDENTIALS_2',
    value: 'Authentication credentials invalid',
  },
  NO_SUCH_PROVIDER: {
    key: 'NO_SUCH_PROVIDER',
    value: 'No such provider',
  },
  MESSAGING_EXCEPTION: {
    key: 'MESSAGING_EXCEPTION',
    value: 'Messaging Exception',
  },
  SMTP_SERVER_CONFIG_NOT_FOUND: {
    key: 'SMTP_SERVER_CONFIG_NOT_FOUND',
    value: 'SMTP server config not found',
  },
  JMS_EXCEPTION: {
    key: 'JMS_EXCEPTION',
    value: 'JMS Exception',
  },
  IO_EXCEPTION: {
    key: 'IO_EXCEPTION',
    value: 'IO Exception',
  },
  TEMPLATE_EXCEPTION: {
    key: 'TEMPLATE_EXCEPTION',
    value: 'Template Exception',
  },
  EXCEPTION: {
    key: 'EXCEPTION',
    value: 'Exception',
  },
  VARIABLE_NAME_EXIST: {
    key: 'VARIABLE_NAME_EXIST',
    value: 'Variable name already exists',
  },
  VARIABLE_DELETE_FAILS: {
    key: 'VARIABLE_DELETE_FAILS',
    value: 'Delete variable fails',
  },
  VARIABLE_REFERENCE_ADD_FAILS: {
    key: 'VARIABLE_REFERENCE_ADD_FAILS',
    value: 'Add variable reference fails',
  },
  VARIABLE_CATEGORY_NAME_EXIST: {
    key: 'VARIABLE_CATEGORY_NAME_EXIST',
    value: 'Unable to add variable category as the variable category name already exists',
  },
  VARIABLE_CATEGORY_DELETE_FAILS: {
    key: 'VARIABLE_CATEGORY_DELETE_FAILS',
    value: 'Delete variable category failed',
  },
  TEMPLATE_NAME_EXIST: {
    key: 'TEMPLATE_NAME_EXIST',
    value: 'Template name already exists',
  },
  AUTHENTICATION_ERROR: {
    key: 'AUTHENTICATION_ERROR',
    value: 'Invalid token/permission',
  },
  TEMPLATE_ERROR: {
    key: 'TEMPLATE_ERROR',
    value: 'Unable to process template',
  },
  TEMPLATE_ERROR_2: {
    key: 'TEMPLATE_ERROR_2',
    value: 'Template cannot be processed due to unresolvable variables',
  },
  TEMPLATE_ERROR_3: {
    key: 'TEMPLATE_ERROR_3',
    value: 'Template cannot be processed due to unresolvable reference elements',
  },
  SMTP_SERVER_CONFIG_NAME_EXIST: {
    key: 'SMTP_SERVER_CONFIG_NAME_EXIST',
    value: 'From address / user name already exists',
  },
  DELETE_SMTP_SERVER_CONFIG_FAILS: {
    key: 'DELETE_SMTP_SERVER_CONFIG_FAILS',
    value: 'SMTP server configuration cannot be deleted since email templates associated already',
  },
  BAD_REQUEST: {
    key: 'BAD_REQUEST',
    value: 'Bad request',
  },
  ELEMENT_NAME_EXISTS: {
    key: 'ELEMENT_NAME_EXISTS',
    value: 'Element name already exists',
  },
  INVALID_MAIL_TEMPLATE_ID: {
    key: 'INVALID_MAIL_TEMPLATE_ID',
    value: "Requested email template id doesn't exist",
  },
  INVALID_TO_ADDRESS: {
    key: 'INVALID_TO_ADDRESS',
    value: 'Recipient address (to) is mandatory',
  },
  INVALID_CC_ADDRESS: {
    key: 'INVALID_CC_ADDRESS',
    value: 'Recipient address (cc) is mandatory',
  },
  INVALID_BCC_ADDRESS: {
    key: 'INVALID_BCC_ADDRESS',
    value: 'Recipient address (bcc) is mandatory',
  },
  DEFAULT_SMTP_NOT_FOUND: {
    key: 'DEFAULT_SMTP_NOT_FOUND',
    value: 'Default SMTP not Found',
  },
  TEMPLATE_MOVED_TO_QA_ERROR: {
    key: 'TEMPLATE_MOVED_TO_QA_ERROR',
    value: 'Could not create new draft',
  },
  TEMPLATE_MOVED_TO_QA_ERROR_2: {
    key: 'TEMPLATE_MOVED_TO_QA_ERROR_2',
    value:
      'Email template already in testing / production. No changes are made from the previous version',
  },
  TEMPLATE_APPROVED_ERROR: {
    key: 'TEMPLATE_APPROVED_ERROR',
    value: 'Unable to find testing version of email template.',
  },
  TEMPLATE_PUBLISH_ERROR: {
    key: 'TEMPLATE_PUBLISH_ERROR',
    value: 'Unable to find approved testing version of email template.',
  },
  JSON_PROCESSING_ERROR: {
    key: 'JSON_PROCESSING_ERROR',
    value: 'Unable to process the JSON',
  },
  INVALID_BATCH_ID: {
    key: 'INVALID_BATCH_ID',
    value: "Spark web hook doesn't have the batch id in request header",
  },
  INVALID_FROM_ADDRESS: {
    key: 'INVALID_FROM_ADDRESS',
    value: 'Invalid from address',
  },
  TAG_NAME_EXIST: {
    key: 'TAG_NAME_EXIST',
    value: 'Tag name already exist',
  },
  PRINTER_CONFIGURATION_INVALID: {
    key: 'PRINTER_CONFIGURATION_INVALID',
    value: 'Printer configuration is invalid',
  },
  INVALID_TAG_ID: {
    key: 'INVALID_TAG_ID',
    value: 'Invalid tag id',
  },
  ORGANIZATION_ID_OF_USER_NOT_MATCHED_WITH_VARIABLE_CATEGORY: {
    key: 'ORGANIZATION_ID_OF_USER_NOT_MATCHED_WITH_VARIABLE_CATEGORY',
    value: 'User Organization not same as variable category',
  },
  ORGANIZATION_ID_OF_USER_NOT_MATCHED_WITH_VARIABLE: {
    key: 'ORGANIZATION_ID_OF_USER_NOT_MATCHED_WITH_VARIABLE',
    value: 'User Organization not same as Variable',
  },
  ORGANIZATION_NOT_FOUND: {
    key: 'ORGANIZATION_NOT_FOUND',
    value: 'Organization not found',
  },
  DELETE_SMTP_SERVER_CONFIG_FAILS_2: {
    key: 'DELETE_SMTP_SERVER_CONFIG_FAILS_2',
    value: 'SMTP Server configuration cannot be deleted since from addresses associated already',
  },
  VARIABLE_IS_IN_USE: {
    key: 'VARIABLE_IS_IN_USE',
    value: 'Unable to delete the variable as it is used in a template',
  },

  MESSAGE_NAME_UNIQUE: {
    key: 'MESSAGE_NAME_UNIQUE',
    value: 'Message name should be not null and unique',
  },
  MESSAGE_ID_NOT_NULL: {
    key: 'MESSAGE_ID_NOT_NULL',
    value: 'Message id can not be null',
  },
  MESSAGE_ID_NOT_EXIST: {
    key: 'MESSAGE_ID_NOT_EXIST',
    value: "Message for id doesn't exist",
  },
  MESSAGE_NO_CONTENT_FOR_ACTION: {
    key: 'MESSAGE_NO_CONTENT_FOR_ACTION',
    value: 'No Content Found in Message For this Action',
  },
  MESSAGE_VARIABLES_MISSING: {
    key: 'MESSAGE_VARIABLES_MISSING',
    value: 'Message variables missing',
  },
  MESSAGE_VOICE_NOT_AVAILABLE: {
    key: 'MESSAGE_VOICE_NOT_AVAILABLE',
    value: 'Message voice not available for target language',
  },

  INVALID_DATE_RANGE: {
    key: 'INVALID_DATE_RANGE',
    value: 'Date range should be in last seven days',
  },
  INVALID_DASHBOARD_REQUEST: {
    key: 'INVALID_DASHBOARD_REQUEST',
    value: 'Dashboard request object cannot be null',
  },

  INVALID_PRINTER_IP_ADDRESS_REACHABLE: {
    key: 'INVALID_PRINTER_IP_ADDRESS_REACHABLE',
    value: 'Printer IP address is not reachable',
  },
  INVALID_PRINTER_IP_ADDRESS_EXISTS: {
    key: 'INVALID_PRINTER_IP_ADDRESS_EXISTS',
    value: 'Printer IP address already exists',
  },
  INVALID_PRINTER_NAME_EXISTS: {
    key: 'INVALID_PRINTER_NAME_EXISTS',
    value: 'Printer name already exists',
  },
  INVALID_CUPS_HOSTNAME_REQUIRED: {
    key: 'INVALID_CUPS_HOSTNAME_REQUIRED',
    value: 'Cups hostname is required',
  },
  INVALID_CUPS_PORT_REQUIRED: {
    key: 'INVALID_CUPS_PORT_REQUIRED',
    value: 'Cups port is required',
  },
  INVALID_CUPS_USERNAME_REQUIRED: {
    key: 'INVALID_CUPS_USERNAME_REQUIRED',
    value: 'Cups admin username is required',
  },
  INVALID_CUPS_PASSWORD_REQUIRED: {
    key: 'INVALID_CUPS_PASSWORD_REQUIRED',
    value: 'Cups admin password is required',
  },
  INVALID_PRINTER_ID_NOT_EXIST: {
    key: 'INVALID_PRINTER_ID_NOT_EXIST',
    value: "Printer id doesn't exist",
  },
  INVALID_PRINTER_ID_REQUIRED: {
    key: 'INVALID_PRINTER_ID_REQUIRED',
    value: 'Printer id is required',
  },
  UNABLE_TO_DELETE_PRINTER_ACTIVE_JOBS: {
    key: 'UNABLE_TO_DELETE_PRINTER_ACTIVE_JOBS',
    value: 'Unable to delete printer because printer has active jobs in queue',
  },
  DOCUMENT_ALREADY_IN_OTHER_BATCH: {
    key: 'DOCUMENT_ALREADY_IN_OTHER_BATCH',
    value: 'One or more documents already included in other batch',
  },
  NO_DOCUMENTS_FOUND: {
    key: 'NO_DOCUMENTS_FOUND',
    value: 'No documents found using current search criteria',
  },
  UNABLE_TO_FETCH_CUPS_DETAILS: {
    key: 'UNABLE_TO_FETCH_CUPS_DETAILS',
    value: 'Cups config needs to be added',
  },
  INVALID_PRINTER_CONFIGURATION: {
    key: 'INVALID_PRINTER_CONFIGURATION',
    value: 'Printer configuration (printer name/IP address) is invalid',
  },
  INVALID_PRINTER_IP_ADDRESS: {
    key: 'INVALID_PRINTER_IP_ADDRESS',
    value: 'Printer IP address is invalid',
  },
  CUPS_CLIENT_FAILED: {
    key: 'CUPS_CLIENT_FAILED',
    value: 'Cups server is not initialized',
  },
  INVALID_DATE: {
    key: 'INVALID_DATE',
    value: 'Invalid date',
  },
  BATCH_NAME_ALREADY_EXISTS: {
    key: 'BATCH_NAME_ALREADY_EXISTS',
    value: 'Batch name already exists',
  },
  UNABLE_TO_DELETE_PRINTER: {
    key: 'UNABLE_TO_DELETE_PRINTER',
    value: 'Unable to delete printer',
  },
  UNABLE_TO_DELETE_PRINTER_SUBSCRIPTION_FAILED: {
    key: 'UNABLE_TO_DELETE_PRINTER_SUBSCRIPTION_FAILED',
    value: 'Unable to delete printer because failure in cancelling printer subscription',
  },
  UNABLE_TO_DELETE_PRINTER_ONE_REQUIRED: {
    key: 'UNABLE_TO_DELETE_PRINTER_ONE_REQUIRED',
    value: 'Unable to delete printer. At least one printer should be configured in the mailroom',
  },
  INVALID_PRINTER_NAME_LENGTH: {
    key: 'INVALID_PRINTER_NAME_LENGTH',
    value: 'Printer name should be less than or equal to 127 characters',
  },
  INVALID_PRINTER_NAME_MANDATORY: {
    key: 'INVALID_PRINTER_NAME_MANDATORY',
    value: 'Printer name is mandatory',
  },
  UNABLE_TO_ADD_PRINTER: {
    key: 'UNABLE_TO_ADD_PRINTER',
    value: 'Unable to add the printer',
  },
  INVALID_DATE_RANGE_2: {
    key: 'INVALID_DATE_RANGE_2',
    value: 'Date should be within the range',
  },

  ACCOUNTSID_MANDATORY: {
    key: 'ACCOUNTSID_MANDATORY',
    value: 'Account_SID for Twilio config is mandatory',
  },
  AUTHTOKEN_MANDATORY: {
    key: 'AUTHTOKEN_MANDATORY',
    value: 'AUTH_TOKEN for Twilio config is mandatory',
  },
  FROMNUMBER_MANDATORY: {
    key: 'FROMNUMBER_MANDATORY',
    value: 'FromNumber for Twilio config is mandatory',
  },
  INVALID_TWILIO_CREDENTIALS: {
    key: 'INVALID_TWILIO_CREDENTIALS',
    value: 'Invalid Account_SID or AUTH_TOKEN',
  },
  FROM_SMS_NUMBER_NOT_ASSOCIATED: {
    key: 'FROM_SMS_NUMBER_NOT_ASSOCIATED',
    value: 'FromSMS number is not associated with Twilio account',
  },
  FROM_WHATSAPP_NUMBER_NOT_ASSOCIATED: {
    key: 'FROM_WHATSAPP_NUMBER_NOT_ASSOCIATED',
    value: 'WhatsApp number is not associated with Twilio account',
  },
  TWILIO_CONFIG_ALREADY_EXISTS: {
    key: 'TWILIO_CONFIG_ALREADY_EXISTS',
    value: 'Twilio config already exists, please update',
  },
  FROM_CALL_NUMBER_NOT_ASSOCIATED: {
    key: 'FROM_CALL_NUMBER_NOT_ASSOCIATED',
    value: 'FromCALL number is not associated with Twilio account',
  },
  GOOGLE_CONFIG_ALREADY_EXISTS: {
    key: 'GOOGLE_CONFIG_ALREADY_EXISTS',
    value: 'Google config already exists, please update',
  },

  CONTACT_PREFERRED_METHOD_INVALID: {
    key: 'CONTACT_PREFERRED_METHOD_INVALID',
    value: 'Contact preferred method is invalid',
  },
  MULTIPLE_PRIMARY_ADDRESS: {
    key: 'MULTIPLE_PRIMARY_ADDRESS',
    value: 'Multiple primary address, only one primary address is allowed',
  },
  ADDRESS_CITY_STATE_COUNTRY_NULL: {
    key: 'ADDRESS_CITY_STATE_COUNTRY_NULL',
    value: 'City, state, country in address cannot be null',
  },
  ADDRESS_CITY_STATE_COUNTRY_INVALID: {
    key: 'ADDRESS_CITY_STATE_COUNTRY_INVALID',
    value: 'Invalid city/state/country in address',
  },
  MULTIPLE_PRIMARY_EMAIL: {
    key: 'MULTIPLE_PRIMARY_EMAIL',
    value: 'Multiple primary email, only one primary email is allowed',
  },
  EMAIL_CANNOT_BE_NULL: {
    key: 'EMAIL_CANNOT_BE_NULL',
    value: 'Email cannot be null',
  },
  DUPLICATE_EMAIL_FOR_CONTACT: {
    key: 'DUPLICATE_EMAIL_FOR_CONTACT',
    value: 'Duplicate email for contact',
  },
  MULTIPLE_PRIMARY_NUMBER: {
    key: 'MULTIPLE_PRIMARY_NUMBER',
    value: 'Multiple primary number, only one primary number is allowed',
  },
  NUMBER_CANNOT_BE_NULL: {
    key: 'NUMBER_CANNOT_BE_NULL',
    value: 'Number cannot be null',
  },
  DUPLICATE_NUMBER_FOR_CONTACT: {
    key: 'DUPLICATE_NUMBER_FOR_CONTACT',
    value: 'Duplicate number for contact',
  },
  RESOURCE_GROUP_CANNOT_BE_NULL: {
    key: 'RESOURCE_GROUP_CANNOT_BE_NULL',
    value: 'Resource group (teams) cannot be null',
  },
  USER_NO_WRITE_PERMISSION_FOR_TEAM: {
    key: 'USER_NO_WRITE_PERMISSION_FOR_TEAM',
    value: 'User does not have write permission for the team',
  },
  FIRST_OR_LAST_NAME_MANDATORY: {
    key: 'FIRST_OR_LAST_NAME_MANDATORY',
    value: 'Either first name or last name for contact is mandatory',
  },
  FAILED_TO_FETCH_USER_DETAILS: {
    key: 'FAILED_TO_FETCH_USER_DETAILS',
    value: 'Failed to fetch user details.',
  },
  FAILED_TO_ADD_USER: {
    key: 'FAILED_TO_ADD_USER',
    value: 'Failed to add user.',
  },
  FAILED_TO_INVITE_USER: {
    key: 'FAILED_TO_INVITE_USER',
    value: 'Failed to invite user.',
  },
  INVALID_RESOURCE_GROUP_ID: {
    key: 'INVALID_RESOURCE_GROUP_ID',
    value: 'Resource group ids invalid.',
  },
  FAILED_TO_UPDATE_USER: {
    key: 'FAILED_TO_UPDATE_USER',
    value: 'User cannot be updated.',
  },
  USER_EMAIL_CANNOT_BE_UPDATED: {
    key: 'USER_EMAIL_CANNOT_BE_UPDATED',
    value: 'User email cannot be updated.',
  },
  FAILED_TO_DELETE_USER: {
    key: 'FAILED_TO_DELETE_USER',
    value: 'User cannot be deleted.',
  },
  UNABLE_TO_UPDATE_DELETED_USER: {
    key: 'UNABLE_TO_UPDATE_DELETED_USER',
    value: 'Cannot update deleted user.',
  },
  ADD_USER_RATE_LIMIT_EXCEEDED: {
    key: 'ADD_USER_RATE_LIMIT_EXCEEDED',
    value: 'User addition limit exceeded.',
  },
  PRIMARY_USER_CANNOT_BE_DELETED: {
    key: 'PRIMARY_USER_CANNOT_BE_DELETED',
    value: 'Primary account cannot be deleted.',
  },
  FAILED_TO_FETCH_API_KEY: {
    key: 'FAILED_TO_FETCH_API_KEY',
    value: 'Failed to fetch API key.',
  },
  FAILED_TO_CREATE_API_KEY: {
    key: 'FAILED_TO_CREATE_API_KEY',
    value: 'Failed to create new API key.',
  },
  PRIMARY_USER_ADMIN_ROLE_CANNOT_BE_CHANGED: {
    key: 'PRIMARY_USER_ADMIN_ROLE_CANNOT_BE_CHANGED',
    value: "Primary user's admin role cannot be changed.",
  },
  ORGANIZATION_USER_SIGNUP_ERROR: {
    key: 'ORGANIZATION_USER_SIGNUP_ERROR',
    value: 'Error while signup with supertokens.',
  },

  ORGANIZATION_INACTIVE: {
    key: 'ORGANIZATION_INACTIVE',
    value: 'Organization status not active.',
  },
  USER_ROLE_MISMATCH: {
    key: 'USER_ROLE_MISMATCH',
    value: 'User role mismatch.',
  },
  INVALID_ORGANIZATION_SUBSCRIPTION_ID: {
    key: 'INVALID_ORGANIZATION_SUBSCRIPTION_ID',
    value: "Error in organization's subscription.",
  },
  UNKNOWN_PRODUCT_PRICING: {
    key: 'UNKNOWN_PRODUCT_PRICING',
    value: 'Pricing details unknown.',
  },
  UNKNOWN_PRICING_TABLE: {
    key: 'UNKNOWN_PRICING_TABLE',
    value: 'Pricing table information is incorrect.',
  },
  UNKNOWN_ERROR: {
    key: 'UNKNOWN_ERROR',
    value: 'Unknown error occurred.',
  },
  TEAM_LIMIT_EXCEEDED: {
    key: 'TEAM_LIMIT_EXCEEDED',
    value: 'Your limit for adding teams has been exceeded.',
  },
  TRANSLATION_LIMIT_EXCEEDED: {
    key: 'TRANSLATION_LIMIT_EXCEEDED',
    value: 'Your limit for translation has been exceeded.',
  },
  PLAN_NOT_ACTIVE: {
    key: 'PLAN_NOT_ACTIVE',
    value: 'Your plan is not active or has expired.',
  },
  FROM_ADDRESS_LIMIT: {
    key: 'FROM_ADDRESS_LIMIT',
    value: 'You cannot add from address/domains in the free plan.',
  },
  FROM_ADDRESS_LIMIT_REACHED: {
    key: 'FROM_ADDRESS_LIMIT_REACHED',
    value: 'You have reached your limit in your plan.',
  },

  AI_TEXT_GENERATION_FAILED: {
    key: 'AI_TEXT_GENERATION_FAILED',
    value: 'AI text generation failed.',
  },

  GET_TEMPLATE_NAME_FAILED: {
    key: 'GET_TEMPLATE_NAME_FAILED',
    value: 'Failed to get template names.',
  },
  FETCH_GENERATED_FILE_FAILED: {
    key: 'FETCH_GENERATED_FILE_FAILED',
    value: 'Failed to fetch generated file.',
  },
  DELETE_GENERATED_FILE_FAILED: {
    key: 'DELETE_GENERATED_FILE_FAILED',
    value: 'Failed to delete generated file.',
  },

  FAILED_TO_GET_USER: {
    key: 'FAILED_TO_GET_USER',
    value: 'Failed to get user details.',
  },
  FAILED_TO_GET_LANGUAGE_COUNT: {
    key: 'FAILED_TO_GET_LANGUAGE_COUNT',
    value: 'Failed to get language count.',
  },
  FAILED_TO_GET_TEXT_GENERATION_COUNT: {
    key: 'FAILED_TO_GET_TEXT_GENERATION_COUNT',
    value: 'Failed to get AI text generation token count.',
  },
  FAILED_TO_GET_TRANSLATION_COUNT: {
    key: 'FAILED_TO_GET_TRANSLATION_COUNT',
    value: 'Failed to get translation character count.',
  },
  FAILED_TO_GET_CLOUD_STORAGE_METRICS: {
    key: 'FAILED_TO_GET_CLOUD_STORAGE_METRICS',
    value: 'Failed to get cloud storage metrics.',
  },
  FAILED_TO_GET_DOCUMENT_PAGES: {
    key: 'FAILED_TO_GET_DOCUMENT_PAGES',
    value: 'Failed to get used document pages.',
  },
  FAILED_TO_GET_DOCUMENTS_COUNT: {
    key: 'FAILED_TO_GET_DOCUMENTS_COUNT',
    value: 'Failed to get document count.',
  },
  FAILED_TO_GET_EMAIL_TRANSACTION_COUNT: {
    key: 'FAILED_TO_GET_EMAIL_TRANSACTION_COUNT',
    value: 'Failed to get email transaction count.',
  },

  ADDRESS_NOT_EXIST: {
    key: 'ADDRESS_NOT_EXIST',
    value: "Address doesn't exist or has been deleted.",
  },
  ADDRESS_ALREADY_EXIST: {
    key: 'ADDRESS_ALREADY_EXIST',
    value: 'Address already exists.',
  },
  SPARKPOST_RESPONSE_BODY_NULL: {
    key: 'SPARKPOST_RESPONSE_BODY_NULL',
    value: 'Sparkpost response body is null.',
  },
  SPARKPOST_REQUEST_FAILS: {
    key: 'SPARKPOST_REQUEST_FAILS',
    value: 'Domain already exists in another SparkPost account.',
  },
  EXCEPTION_OCCURRED: {
    key: 'EXCEPTION_OCCURRED',
    value: 'An exception occurred.',
  },
  SPARKPOST_CLIENT_ERROR: {
    key: 'SPARKPOST_CLIENT_ERROR',
    value: 'SparkPost returned a 400 error.',
  },
  DOMAIN_NOT_EXIST: {
    key: 'DOMAIN_NOT_EXIST',
    value: "Domain doesn't exist.",
  },
  DELETE_FROM_ADDRESS_FAILS: {
    key: 'DELETE_FROM_ADDRESS_FAILS',
    value: 'You need to delete the template associated with this from address.',
  },
  DEFAULT_DOMAIN_ADD_FROM_ADDRESS_FAILS: {
    key: 'DEFAULT_DOMAIN_ADD_FROM_ADDRESS_FAILS',
    value: 'Cannot add from address in default domain.',
  },
  DOMAIN_ALREADY_ASSOCIATED: {
    key: 'DOMAIN_ALREADY_ASSOCIATED',
    value: 'Domain already associated with another account.',
  },
  DOMAIN_ASSOCIATES_WITH_FROM_ADDRESS: {
    key: 'DOMAIN_ASSOCIATES_WITH_FROM_ADDRESS',
    value: 'From address needs to be deleted first.',
  },
  FROM_ADDRESS_ID_NOT_NULL: {
    key: 'FROM_ADDRESS_ID_NOT_NULL',
    value: 'From address id cannot be null or empty.',
  },

  FAILED_TO_FETCH_PLAN_CYCLE: {
    key: 'FAILED_TO_FETCH_PLAN_CYCLE',
    value: 'Error while fetching plan cycle',
  },
  FAILED_TO_FETCH_CHARS_TRANSLATED: {
    key: 'FAILED_TO_FETCH_CHARS_TRANSLATED',
    value: 'Error while fetching no of chars translated',
  },
  STANDALONE_FLOW_ALREADY_TRANSLATED: {
    key: 'STANDALONE_FLOW_ALREADY_TRANSLATED',
    value: 'Standalone flow already translated to specified language',
  },
  BLOCK_NAME_UNIQUE: {
    key: 'BLOCK_NAME_UNIQUE',
    value: 'Block name should be not null and unique',
  },
  STANDALONE_BLOCK_IS_IN_USE: {
    key: 'STANDALONE_BLOCK_IS_IN_USE',
    value: 'Referenced/Reusable block is used in document. Therfore, block cannot be deleted',
  },
  FAILED_TO_DELETE_QA_OR_PUBLISHED_STANDALONE_BLOCK: {
    key: 'FAILED_TO_DELETE_QA_OR_PUBLISHED_STANDALONE_BLOCK',
    value: 'Error while deleting standalone block in QA or Publish',
  },
  NO_QA_READY_REFERENCE_FOR_STANDALONE_BLOCK: {
    key: 'NO_QA_READY_REFERENCE_FOR_STANDALONE_BLOCK',
    value: 'No QA ready block available.',
  },
  NO_QA_COMPLETE_REFERENCE_FOR_STANDALONE_BLOCK: {
    key: 'NO_QA_COMPLETE_REFERENCE_FOR_STANDALONE_BLOCK',
    value: 'No QA complete block available.',
  },
  INVALID_PARAMETERS: {
    key: 'INVALID_PARAMETERS',
    value: 'Bad request',
  },
  STANDALONE_FLOW_CREATION_FAILED: {
    key: 'STANDALONE_FLOW_CREATION_FAILED',
    value: 'Standalone flow creation failed',
  },
  FLOW_NAME_UNIQUE: {
    key: 'FLOW_NAME_UNIQUE',
    value: 'Flow name should be not null and unique',
  },
  STANDALONE_FLOW_NOT_EXISTS: {
    key: 'STANDALONE_FLOW_NOT_EXISTS',
    value: "Standalone flow id doesn't exist",
  },
  STANDALONE_FLOW_IS_IN_USE: {
    key: 'STANDALONE_FLOW_IS_IN_USE',
    value: 'Referenced/Reusable flow is used in document/tags. Therefore, flow cannot be deleted',
  },
  FLOW_AND_BLOCK_MAPPING_FAILED: {
    key: 'FLOW_AND_BLOCK_MAPPING_FAILED',
    value: 'Error while mapping flow and block',
  },
  STANDALONE_FLOW_CANNOT_BE_TOC: {
    key: 'STANDALONE_FLOW_CANNOT_BE_TOC',
    value: 'Referenced/Reusable flow name cannot be Table of contents',
  },
  FAILED_TO_DELETE_QA_OR_PUBLISHED_STANDALONE_FLOW: {
    key: 'FAILED_TO_DELETE_QA_OR_PUBLISHED_STANDALONE_FLOW',
    value: 'Error while deleting standalone flow in QA or Publish',
  },
  FLOW_CONTENT_IS_BLANK: {
    key: 'FLOW_CONTENT_IS_BLANK',
    value: 'The content cannot be blank',
  },
  DOCUMENT_ID_CANNOT_BE_NULL: {
    key: 'DOCUMENT_ID_CANNOT_BE_NULL',
    value: 'Draft document id cannot be null.',
  },
  PARSE_EXCEPTION: {
    key: 'PARSE_EXCEPTION',
    value: 'Unknown error occurred.',
  },
  DOCUMENT_NOT_FOUND: {
    key: 'DOCUMENT_NOT_FOUND',
    value: 'No document found to move.',
  },
  INVALID_PUBLISH_STATUS: {
    key: 'INVALID_PUBLISH_STATUS',
    value: 'Invalid publish status',
  },
  INVALID_DOCUMENT_ID: {
    key: 'INVALID_DOCUMENT_ID',
    value: 'Invalid document id.',
  },
  DOCUMENT_GENERATION_FAILURE: {
    key: 'DOCUMENT_GENERATION_FAILURE',
    value: 'Document generation failed',
  },
  DOCUMENT_ZIP_FAILURE: {
    key: 'DOCUMENT_ZIP_FAILURE',
    value: 'Failure occurred while zipping documents',
  },
  GET_PDF_TRANSACTION_COUNT_FAILURE: {
    key: 'GET_PDF_TRANSACTION_COUNT_FAILURE',
    value: 'Failed to get the count',
  },
  VARIABLE_VALIDATION_FAILURE: {
    key: 'VARIABLE_VALIDATION_FAILURE',
    value: 'Variable validation failed',
  },
  FAILED_TO_SYNC_VARIABLE: {
    key: 'FAILED_TO_SYNC_VARIABLE',
    value: 'Failed to Sync the document variables into email attachments',
  },
  NAME_CANNOT_BE_EMPTY: {
    key: 'NAME_CANNOT_BE_EMPTY',
    value: 'name should not be null or empty',
  },
  CREDENTIALS_CANNOT_BE_EMPTY: {
    key: 'CREDENTIALS_CANNOT_BE_EMPTY',
    value: 'credentials should not be null or empty',
  },
  BUCKET_OR_CDN_CREATION_FAILURE: {
    key: 'BUCKET_OR_CDN_CREATION_FAILURE',
    value: 'Error while creation of bucket or CDN',
  },
  SET_ORG_STORAGE_FAILURE: {
    key: 'SET_ORG_STORAGE_FAILURE',
    value: 'Error while setting assets/credentials in organization storage',
  },
  SECRET_OR_ACCESS_KEY_EMPTY: {
    key: 'SECRET_OR_ACCESS_KEY_EMPTY',
    value: 'secret key and access key should not be null or empty',
  },
  ID_CANNOT_BE_NULL: {
    key: 'ID_CANNOT_BE_NULL',
    value: 'Id cannot be null',
  },
  LANGUAGE_CANNOT_BE_UPDATED: {
    key: 'LANGUAGE_CANNOT_BE_UPDATED',
    value: 'Language is not available for the organization.',
  },
  LANGUAGE_CANNOT_BE_NULL: {
    key: 'LANGUAGE_CANNOT_BE_NULL',
    value: 'Language cannot be null.',
  },
  LANGUAGE_NOT_SUBSCRIBED: {
    key: 'LANGUAGE_NOT_SUBSCRIBED',
    value: 'Requested language is not subscribed by the organization',
  },
  RESOURCE_TYPE_CANNOT_BE_NULL: {
    key: 'RESOURCE_TYPE_CANNOT_BE_NULL',
    value: 'Resource type cannot be null',
  },
  RESOURCE_ID_CANNOT_BE_NULL: {
    key: 'RESOURCE_ID_CANNOT_BE_NULL',
    value: 'Resource id cannot be null',
  },
  EMAIL_ID_CANNOT_BE_NULL: {
    key: 'EMAIL_ID_CANNOT_BE_NULL',
    value: 'Email id cannot be null',
  },
  BUSINESS_LOGIC_NAME_CANNOT_BE_NULL: {
    key: 'BUSINESS_LOGIC_NAME_CANNOT_BE_NULL',
    value: 'Business logic name cannot be null',
  },
  BUSINESS_LOGIC_WITH_NAME_ALREADY_EXIST: {
    key: 'BUSINESS_LOGIC_WITH_NAME_ALREADY_EXIST',
    value: 'Business logic name already exist',
  },
  EMAIL_TEMPLATE_ID_NOT_EXIST: {
    key: 'EMAIL_TEMPLATE_ID_NOT_EXIST',
    value: "Email Template doesn't exist",
  },
  EMAIL_BUSINESS_LOGIC_NOT_EXIST: {
    key: 'EMAIL_BUSINESS_LOGIC_NOT_EXIST',
    value: "Business logic doesn't exist",
  },
  EMAIL_BUSINESS_LOGIC_ID_CANNOT_BE_NULL: {
    key: 'EMAIL_BUSINESS_LOGIC_ID_CANNOT_BE_NULL',
    value: 'Business logic id cannot be null',
  },
  FAILED_TO_DELETE_QA_OR_PUBLISHED_EMAIL_TEMPLATE: {
    key: 'FAILED_TO_DELETE_QA_OR_PUBLISHED_EMAIL_TEMPLATE',
    value: 'Error while deleting QA or Published Email template',
  },
  MISSING_SOURCE_OR_TARGET_TEAM: {
    key: 'MISSING_SOURCE_OR_TARGET_TEAM',
    value: 'Source TeamId or Target TeamId is missing',
  },
  VARIABLE_CATEGORY_NOT_EXISTS: {
    key: 'VARIABLE_CATEGORY_NOT_EXISTS',
    value: "Variable category doesn't exists",
  },
  DOCUMENT_LINKED_TO_OTHER_CHANNEL: {
    key: 'DOCUMENT_LINKED_TO_OTHER_CHANNEL',
    value: 'Document is already linked to another channel',
  },
  EMAIL_LINKED_TO_OTHER_CHANNEL: {
    key: 'EMAIL_LINKED_TO_OTHER_CHANNEL',
    value: 'Email is already linked to another channel',
  },
  SHORT_MESSAGE_LINKED_TO_OTHER_CHANNEL: {
    key: 'SHORT_MESSAGE_LINKED_TO_OTHER_CHANNEL',
    value: 'Short message is already linked to another channel',
  },
  FAILED_TO_PARSE_DOCUMENT: {
    key: 'FAILED_TO_PARSE_DOCUMENT',
    value: 'Unable to process document. Please check the format and try again.',
  },
  ENCRYPTION_FAILED: {
    key: 'ENCRYPTION_FAILED',
    value: 'We couldn’t save your credentials. Please try again or contact support if the issue continues.',
  },
  INSERTS_NOT_FOUND: {
    key: 'INSERTS_NOT_FOUND',
    value: 'We couldn’t find the insert you’re looking for. Please check the details and try again..',
  },
  INSERTS_BEING_USED: {
    key: 'INSERTS_BEING_USED',
    value: 'This insert is already in use in other templates. Please remove it from there to continue.',
  },
  INSERTS_RELATION_NOT_FOUND: {
    key: 'INSERTS_RELATION_NOT_FOUND',
    value: 'The selected relation seems invalid. Please verify the input and try again.',
  },
  BUSINESS_LOGIC_PRESENT_ALREADY: {
    key: 'BUSINESS_LOGIC_PRESENT_ALREADY',
    value: 'Business logic already exists for this item. Consider editing the existing logic.',
  },
  NO_BUSINESS_LOGIC_FOUND: {
    key: 'NO_BUSINESS_LOGIC_FOUND',
    value: 'There’s no business logic available to delete for this item.',
  },
  NO_BUSINESS_LOGIC_FOUND_EDIT: {
    key: 'NO_BUSINESS_LOGIC_FOUND_EDIT',
    value: 'We couldn’t find any logic to update. Please check the existing configuration.',
  },
  SANITIZATION_ERROR: {
    key: 'SANITIZATION_ERROR',
    value: 'Some characters in your input are not allowed. Please remove them and try again.',
  },
  FAILED_TO_GET_TRANSCRIPT: {
    key: 'FAILED_TO_GET_TRANSCRIPT',
    value: 'We couldn’t fetch the transcript. Please try again later.',
  },
  SMTP_RETRY_COUNT_ERROR: {
    key: 'SMTP_RETRY_COUNT_ERROR',
    value: 'We couldn’t send the email after several attempts. Please check your settings or try again later.',
  },
  COMMUNICATION_NAME_ALREADY_EXISTS: {
    key: 'COMMUNICATION_NAME_ALREADY_EXISTS',
    value: 'This name is already in use. Please choose a different communication name.',
  },
  VARIABLE_VALUE_CHECK: {
    key: 'VARIABLE_VALUE_CHECK',
    value: 'This field needs a value to proceed.',
  },
  MANDATORY_FIELD_CHECK: {
    key: 'MANDATORY_FIELD_CHECK',
    value: 'This is a required field. Please enter a value to continue.',
  },
  MAX_VALUE_CHECK: {
    key: 'MAX_VALUE_CHECK',
    value: 'The value entered is too high. Please reduce it and try again.',
  },
  INVALID_DATE_FORMAT: {
    key: 'INVALID_DATE_FORMAT',
    value: 'Please use the correct date format: DD-MM-YYYY.',
  },
  CHART_VALUE_SHOULD_BE_NUMBER: {
    key: 'CHART_VALUE_SHOULD_BE_NUMBER',
    value: 'Please enter only numbers in chart fields.',
  },
  CHART_DATA_PROCESSING_ERROR: {
    key: 'CHART_DATA_PROCESSING_ERROR',
    value: 'Unable to process chart data. Please check your data and try again.',
  },
  BARCODE_VALUE_ERROR: {
    key: 'BARCODE_VALUE_ERROR',
    value: 'Please use uppercase letters, numbers, and spaces for barcodes.',
  },
  INVALID_HTML_ERROR: {
    key: 'INVALID_HTML_ERROR',
    value: 'The provided HTML is invalid. Please fix and try again.',
  },
  UNABLE_TO_PROCESS_HTML_PAYLOAD: {
    key: 'UNABLE_TO_PROCESS_HTML_PAYLOAD',
    value: 'We ran into a problem processing HTML. Please try again.',
  },
  DOCSTUDIO_UNKNOWN_ERROR: {
    key: 'DOCSTUDIO_UNKNOWN_ERROR',
    value: 'An unexpected error occurred. Please try again or contact support.',
  },
  DYNAMIC_FILLABLE_ERROR: {
    key: 'DYNAMIC_FILLABLE_ERROR',
    value: 'An unexpected error occurred. Unable to generate the document.',
  },
  INTERNAL_SERVER_ERROR: {
    key: 'INTERNAL_SERVER_ERROR',
    value: 'Something went wrong. Please try again or contact support if the problem persists.',
  },
  BATCH_NOT_EXIST: {
    key: 'BATCH_NOT_EXIST',
    value: 'We couldn’t find the batch with the given ID. Please verify and try again.',
  },
  APPROVER_NOT_EXIST: {
    key: 'APPROVER_NOT_EXIST',
    value: 'We couldn’t find the selected approver. Please check the name or ID and try again.',
  },
  METADATA_CREATION_ERROR: {
    key: 'METADATA_CREATION_ERROR',
    value: 'We ran into an issue creating metadata. Please try again.',
  },
  BATCH_ENDED: {
    key: 'BATCH_ENDED',
    value: 'This batch is already finalized. New submissions are not allowed.',
  },
  FAILED_GENERATE_TOKEN: {
    key: 'FAILED_GENERATE_TOKEN',
    value: 'We couldn’t complete authentication. Please try again.',
  },
  FAILED_FETCHING_JOB: {
    key: 'FAILED_FETCHING_JOB',
    value: 'We couldn’t load job details. Please refresh or try later.',
  },
  BATCH_STATUS_ERROR: {
    key: 'BATCH_STATUS_ERROR',
    value: 'We couldn’t check the batch status. Please try again shortly.',
  },
  PROCESS_INCOMPLETE: {
    key: 'PROCESS_INCOMPLETE',
    value: 'The job is still processing. Please wait and check again soon.',
  },
  NO_SUCCESS_RECORDS: {
    key: 'NO_SUCCESS_RECORDS',
    value: 'This batch has no completed results. Please verify and try again.',
  },
  JOB_ID_CANNOT_BE_NULL: {
    key: 'JOB_ID_CANNOT_BE_NULL',
    value: 'Please enter a Job ID to continue.',
  },
  SORT_VALUES_EMPTY: {
    key: 'SORT_VALUES_EMPTY',
    value: 'To navigate pages, please define a sort condition.',
  },
  DOCUMENT_ID_MISSING: {
    key: 'DOCUMENT_ID_MISSING',
    value: 'Please provide either a Document ID or Communication ID to continue.',
  },
  COMMUNICATION_ID_MISSING: {
    key: 'COMMUNICATION_ID_MISSING',
    value: 'Either Document ID or Communication ID is required.',
  },
  PUBLISHED_ON_DOC_ID_NOT_EXISTS: {
    key: 'PUBLISHED_ON_DOC_ID_NOT_EXISTS',
    value: 'This document doesn’t have a published version yet.',
  },
  QA_ON_DOC_ID_NOT_EXISTS: {
    key: 'QA_ON_DOC_ID_NOT_EXISTS',
    value: 'This document doesn’t have a QA version yet.',
  },
  COMMUNICATION_ON_COM_ID_NOT_EXISTS: {
    key: 'COMMUNICATION_ON_COM_ID_NOT_EXISTS',
    value: 'We couldn’t find any mapping for this communication. Please verify and try again.',
  },
  PUBLISHED_ON_COM_ID_NOT_EXISTS: {
    key: 'PUBLISHED_ON_COM_ID_NOT_EXISTS',
    value: 'No published version of this document is linked to this communication.',
  },
  QA_ON_COM_ID_NOT_EXISTS: {
    key: 'QA_ON_COM_ID_NOT_EXISTS',
    value: 'No QA version of this document is linked to this communication.',
  },
  DOC_GENERATION_RATE_LIMIT_EXCEEDED: {
    key: 'DOC_GENERATION_RATE_LIMIT_EXCEEDED',
    value: 'You’ve reached the limit for document generation. Please wait a while and try again.',
  },
  DATA_SET_VALIDATION_ERROR: {
    key: 'DATA_SET_VALIDATION_ERROR',
    value: 'Your data has issues. Please check the dataset and correct the errors.',
  },
  PUBLISHED_DOC_FETCH_FAILS: {
    key: 'PUBLISHED_DOC_FETCH_FAILS',
    value: 'We couldn’t fetch the published version. Please try again later.',
  },
  QA_DOC_FETCH_FAILS: {
    key: 'QA_DOC_FETCH_FAILS',
    value: 'We couldn’t fetch the QA version. Please try again.',
  },
  PUBLISHED_DOC_DESIGN_FLOW_ERROR: {
    key: 'PUBLISHED_DOC_DESIGN_FLOW_ERROR',
    value: 'We couldn’t load the published document design. Please try again.',
  },
  QA_DOC_DESIGN_FLOW_ERROR: {
    key: 'QA_DOC_DESIGN_FLOW_ERROR',
    value: 'We couldn’t load the QA document design. Please try again.',
  },
  PUBLISHED_DOC_VARIABLE_CONTRACT_ERROR: {
    key: 'PUBLISHED_DOC_VARIABLE_CONTRACT_ERROR',
    value: 'We couldn’t load variables for the published document. Please try again.',
  },
  QA_DOC_VARIABLE_CONTRACT_ERROR: {
    key: 'QA_DOC_VARIABLE_CONTRACT_ERROR',
    value: 'We couldn’t load variables for the QA document. Please try again.',
  },
  DOC_GENERATION_FAILS: {
    key: 'DOC_GENERATION_FAILS',
    value: 'We couldn’t generate the PDF. Please try again.',
  },
  PDF_STORAGE_ERROR: {
    key: 'PDF_STORAGE_ERROR',
    value: 'We couldn’t save the PDF document. Please try again.',
  },
  BATCH_REQUEST_ERROR: {
    key: 'BATCH_REQUEST_ERROR',
    value: 'We couldn’t complete the batch request. Please try again.',
  },
  CONSUMER_FAILS: {
    key: 'CONSUMER_FAILS',
    value: 'Something went wrong with your request. Please try again later.',
  },
  BATCH_REQUEST_PROCESSING_ERROR: {
    key: 'BATCH_REQUEST_PROCESSING_ERROR',
    value: 'We couldn’t complete the batch request. Please try again.',
  },
  BATCH_REQUEST_PERSIST_ERROR: {
    key: 'BATCH_REQUEST_PERSIST_ERROR',
    value: 'We couldn’t save the batch request. Please try again.',
  },
  MAIL_TEMPLATE_ID_MISSING: {
    key: 'MAIL_TEMPLATE_ID_MISSING',
    value: 'Please provide a valid email template ID to continue.',
  },
  LANGUAGE_MISSING: {
    key: 'LANGUAGE_MISSING',
    value: 'Please select a language to proceed with the communication.',
  },
  RECIPIENT_ADDRESS_MISSING: {
    key: 'RECIPIENT_ADDRESS_MISSING',
    value: 'Please provide the recipient’s email address.',
  },
  PUBLISHED_ON_EMAIL_ID_NOT_EXISTS: {
    key: 'PUBLISHED_ON_EMAIL_ID_NOT_EXISTS',
    value: 'There’s no published version for this email template yet.',
  },
  PUBLISHED_EMAIL_FETCH_FAILS: {
    key: 'PUBLISHED_EMAIL_FETCH_FAILS',
    value: 'We couldn’t fetch the published email template. Please try again later.',
  },
  SMTP_RETRY_REACHED: {
    key: 'SMTP_RETRY_REACHED',
    value: 'We couldn’t connect to the email server. Please review your SMTP settings.',
  },
  PUBLISHED_EMAIL_DESIGN_FLOW_ERROR: {
    key: 'PUBLISHED_EMAIL_DESIGN_FLOW_ERROR',
    value: 'We couldn’t load the design for the published email. Please try again..',
  },
  PUBLISHED_EMAIL_VARIABLE_CONTRACT_ERROR: {
    key: 'PUBLISHED_EMAIL_VARIABLE_CONTRACT_ERROR',
    value: 'We couldn’t retrieve variables for the published email. Please try again.',
  },
  FILE_ATTACHMENT_ERROR: {
    key: 'FILE_ATTACHMENT_ERROR',
    value: 'We couldn’t attach the file to your email. Please try again.',
  },
  DOC_ATTACHMENT_ERROR: {
    key: 'DOC_ATTACHMENT_ERROR',
    value: 'We couldn’t attach the document. Please try again.',
  },
  CREATIVE_BLOCK_IMAGE_ERROR: {
    key: 'CREATIVE_BLOCK_IMAGE_ERROR',
    value: 'We couldn’t create images for the creative blocks. Please try again.',
  },
  TEMPLATE_TO_HTML_ERROR: {
    key: 'TEMPLATE_TO_HTML_ERROR',
    value: 'We couldn’t convert the template to HTML. Please try again.',
  },
  RETRY_SEND_EMAIL_ERROR: {
    key: 'RETRY_SEND_EMAIL_ERROR',
    value: 'Resending the email failed. Please try again.',
  },
  SEND_EMAIL_ERROR: {
    key: 'SEND_EMAIL_ERROR',
    value: 'We couldn’t send the email. Please check your settings.',
  },
  SMTP_CONFIG_FETCH_ERROR: {
    key: 'SMTP_CONFIG_FETCH_ERROR',
    value: 'Email configuration couldn’t be retrieved. Please try again.',
  },
  EMAIL_GENERATION_RATE_LIMIT_EXCEEDED: {
    key: 'EMAIL_GENERATION_RATE_LIMIT_EXCEEDED',
    value: 'You’ve exceeded the email generation limit. Please wait and try again.',
  },
  VALIDATE_REQUEST_FAILED: {
    key: 'VALIDATE_REQUEST_FAILED',
    value: 'We couldn’t validate the request. Please review and try again.',
  },
  ACCOUNT_EMAIL_USAGE_FAILED: {
    key: 'ACCOUNT_EMAIL_USAGE_FAILED',
    value: 'Email usage tracking failed. Please try again.',
  },
  PREPARE_PUBLISHED_EMAIL_FLOW_ERROR: {
    key: 'PREPARE_PUBLISHED_EMAIL_FLOW_ERROR',
    value: 'We couldn’t prepare the published email layout. Please try again.',
  },
  QA_EMAIL_FETCH_FAILS: {
    key: 'QA_EMAIL_FETCH_FAILS',
    value: 'QA email template couldn’t be retrieved. Please try again.',
  },
  QA_ON_EMAIL_NOT_EXISTS: {
    key: 'QA_ON_EMAIL_NOT_EXISTS',
    value: 'No QA version exists for this email template.',
  },
  PREPARE_QA_EMAIL_FLOW_ERROR: {
    key: 'PREPARE_QA_EMAIL_FLOW_ERROR',
    value: 'We couldn’t prepare the QA email layout. Please try again.',
  },
  QA_EMAIL_VARIABLE_CONTRACT_ERROR: {
    key: 'QA_EMAIL_VARIABLE_CONTRACT_ERROR',
    value: 'We couldn’t load variables for the QA email. Please try again.',
  },
  QA_EMAIL_DESIGN_FLOW_ERROR: {
    key: 'QA_EMAIL_DESIGN_FLOW_ERROR',
    value: 'We couldn’t load the design for QA email. Please try again.',
  },
  API_RATE_LIMIT_ERROR: {
    key: 'API_RATE_LIMIT_ERROR',
    value: 'You’ve made too many requests. Please wait and try again shortly.',
  },
  BATCH_REQUEST_QUEUE_ERROR: {
    key: 'BATCH_REQUEST_QUEUE_ERROR',
    value: 'We couldn’t queue your batch request. Please try again.',
  },
  FAILED_TO_CREATE_SSO_CONNECTION: {
    key: 'FAILED_TO_CREATE_SSO_CONNECTION',
    value: 'SSO setup failed. Please try again or contact your administrator.',
  },
  FAILED_TO_SAVE_SSO_CONNECTION: {
    key: 'FAILED_TO_SAVE_SSO_CONNECTION',
    value: 'We couldn’t save your SSO settings. Please try again or contact your administrator.',
  },
  FAILED_TO_GET_SSO_CONNECTION: {
    key: 'FAILED_TO_GET_SSO_CONNECTION',
    value: 'We couldn’t retrieve the SSO configuration. Please try again.',
  },
  SSO_CONNECTION_NOT_EXIST: {
    key: 'SSO_CONNECTION_NOT_EXIST',
    value: 'No SSO configuration found. Please check with your administrator.',
  },
  FAILED_TO_SWITCH_SSO_CONFIG: {
    key: 'FAILED_TO_SWITCH_SSO_CONFIG',
    value: 'We couldn’t update the SSO method. Please try again.',
  },
  FAILED_TO_SAVE_DIRECTORY_SYNC: {
    key: 'FAILED_TO_SAVE_DIRECTORY_SYNC',
    value: 'We couldn’t save your directory sync settings. Please try again.',
  },
  FAILED_TO_CREATE_DIRECTORY_SYNC: {
    key: 'FAILED_TO_CREATE_DIRECTORY_SYNC',
    value: 'We couldn’t create the directory sync setup. Please try again.',
  },
  FAILED_TO_UPDATE_PRINTING_CONFIG: {
    key: 'FAILED_TO_UPDATE_PRINTING_CONFIG',
    value: 'Updating the printing settings failed. Please try again.',
  },
  FAILED_TO_UPDATE_PRINT_STATUS: {
    key: 'FAILED_TO_UPDATE_PRINT_STATUS',
    value: 'We couldn’t update the status of your print request. Please try again.',
  },
  PRINT_REQUEST_RECORD_NOT_FOUND: {
    key: 'PRINT_REQUEST_RECORD_NOT_FOUND',
    value: 'This print request status can’t be updated right now. Try again shortly..',
  },
  UNABLE_TO_UPDATE_PRINT_STATUS: {
    key: 'UNABLE_TO_UPDATE_PRINT_STATUS',
    value: 'We couldn’t update the print status currently. Please try again later.',
  },
  NO_RECORDS_FOUND: {
    key: 'NO_RECORDS_FOUND',
    value: 'There are no available records to send for printing.',
  },
  EXTERNAL_PRINT_CONFIG_NOT_FOUND: {
    key: 'EXTERNAL_PRINT_CONFIG_NOT_FOUND',
    value: 'Printer settings are missing. Please set them up before proceeding..',
  },
  EXTERNAL_PRINT_CONFIG_NOT_VALID: {
    key: 'EXTERNAL_PRINT_CONFIG_NOT_VALID',
    value: 'Your printer configuration appears incorrect. Please review the settings.',
  },
  FAILED_TO_SEND_PRINT: {
    key: 'FAILED_TO_SEND_PRINT',
    value: 'We couldn’t send the documents for printing. Please try again.',
  },
  GET_TEAM_FAILED_BY_QUERY: {
    key: 'GET_TEAM_FAILED_BY_QUERY',
    value: 'We couldn’t load the team details. Please try again shortly..',
  },
  GET_TEAM_FAILED_UNEXPECTEDLY: {
    key: 'GET_TEAM_FAILED_UNEXPECTEDLY',
    value: 'Something went wrong while fetching team info. Try again.',
  },
  GET_PRINT_BATCH_ERROR: {
    key: 'GET_PRINT_BATCH_ERROR',
    value: 'Please provide a valid Job ID to retrieve print batch details.',
  },
  CONTAINS_UNSUPPORTED_SPECIAL_CHARACTERS: {
    key: 'CONTAINS_UNSUPPORTED_SPECIAL_CHARACTERS',
    value: 'The name contains some unsupported special characters. Please use only letters, numbers, or these special characters: - _ ( )',
  },
};
